/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import ExampleLoading from 'react-scale/components/website/index/Products/examples/exampleLoading';

const TaskResponseAnnotation = dynamic(
  () => import('react-scale/components/website/index/Products/examples/tasks/polygonannotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

const responseAnnotations = {
  annotations: [
    {
      key: '77960404-aae4-426a-9568-8f7997cb123a',
      label: 'crosswalk',
      vertices: [
        {
          x: 1460.8000000000002,
          y: 1220
        },
        {
          x: 1275.2,
          y: 1180
        },
        {
          x: 1087.2,
          y: 1142.4
        },
        {
          x: 944,
          y: 1115.2
        },
        {
          x: 760.8,
          y: 1084
        },
        {
          x: 620.8,
          y: 1069.6
        },
        {
          x: 524,
          y: 1058.4
        },
        {
          x: 1005.6,
          y: 1008
        },
        {
          x: 1088.8,
          y: 1011.2
        },
        {
          x: 1211.2,
          y: 1018.4
        },
        {
          x: 1382.4,
          y: 1029.6
        },
        {
          x: 1524.8,
          y: 1041.6
        },
        {
          x: 1684,
          y: 1057.6
        },
        {
          x: 1834,
          y: 1071.2
        },
        {
          x: 1834,
          y: 1220
        }
      ]
    },
    {
      key: '2ce81af8-9bc9-4791-89d1-e908b6c01df3',
      vertices: [
        {
          x: 834.4,
          y: 626.6666666666666
        },
        {
          x: 834.4,
          y: 707.4666666666667
        },
        {
          x: 859.2,
          y: 707.7333333333333
        },
        {
          x: 869.0666666666667,
          y: 709.3333333333334
        },
        {
          x: 869.3333333333334,
          y: 705.6
        },
        {
          x: 873.8666666666667,
          y: 704.5333333333333
        },
        {
          x: 885.3333333333334,
          y: 679.2
        },
        {
          x: 888,
          y: 669.6
        },
        {
          x: 869.8666666666667,
          y: 668.5333333333333
        },
        {
          x: 869.8666666666667,
          y: 666.1333333333333
        },
        {
          x: 873.8666666666667,
          y: 664.8
        },
        {
          x: 874.9333333333333,
          y: 660.2666666666667
        },
        {
          x: 890.4,
          y: 660.2666666666667
        },
        {
          x: 890.9333333333333,
          y: 626.9333333333333
        },
        {
          x: 859.4666666666667,
          y: 626.9333333333333
        }
      ],
      label: 'traffic light'
    },
    {
      key: 'd1370723-b956-433e-adf3-c69e425b7d75',
      vertices: [
        {
          x: 956,
          y: 637.6
        },
        {
          x: 939.2,
          y: 637.0666666666667
        },
        {
          x: 938.9333333333333,
          y: 639.4666666666667
        },
        {
          x: 917.0666666666667,
          y: 640.2666666666667
        },
        {
          x: 917.3333333333334,
          y: 631.2
        },
        {
          x: 913.8666666666667,
          y: 630.6666666666666
        },
        {
          x: 911.2,
          y: 628.5333333333333
        },
        {
          x: 908.8,
          y: 625.6
        },
        {
          x: 907.7333333333333,
          y: 618.6666666666666
        },
        {
          x: 910.6666666666666,
          y: 615.4666666666667
        },
        {
          x: 912,
          y: 614.4
        },
        {
          x: 912,
          y: 590.4
        },
        {
          x: 908.5333333333333,
          y: 586.6666666666666
        },
        {
          x: 906.4,
          y: 583.7333333333333
        },
        {
          x: 905.8666666666667,
          y: 580.2666666666667
        },
        {
          x: 906.1333333333333,
          y: 577.6
        },
        {
          x: 908.2666666666667,
          y: 574.6666666666666
        },
        {
          x: 910.9333333333333,
          y: 572.2666666666667
        },
        {
          x: 912.2666666666667,
          y: 552.2666666666667
        },
        {
          x: 908.2666666666667,
          y: 549.3333333333334
        },
        {
          x: 905.8666666666667,
          y: 545.6
        },
        {
          x: 905.6,
          y: 540.2666666666667
        },
        {
          x: 907.4666666666667,
          y: 536.5333333333333
        },
        {
          x: 909.6,
          y: 534.6666666666666
        },
        {
          x: 909.6,
          y: 522.9333333333333
        },
        {
          x: 926.1333333333333,
          y: 522.6666666666666
        },
        {
          x: 936,
          y: 522.6666666666666
        },
        {
          x: 936,
          y: 528.5333333333333
        },
        {
          x: 953.3333333333334,
          y: 530.9333333333333
        },
        {
          x: 956,
          y: 534.6666666666666
        },
        {
          x: 958.4,
          y: 540.8
        },
        {
          x: 957.8666666666667,
          y: 546.4
        },
        {
          x: 956.8,
          y: 552
        },
        {
          x: 954.4,
          y: 556
        },
        {
          x: 952,
          y: 558.9333333333333
        },
        {
          x: 936.5333333333333,
          y: 559.2
        },
        {
          x: 936.8,
          y: 567.7333333333333
        },
        {
          x: 951.7333333333333,
          y: 568.2666666666667
        },
        {
          x: 956.2666666666667,
          y: 572
        },
        {
          x: 957.8666666666667,
          y: 576
        },
        {
          x: 957.8666666666667,
          y: 581.3333333333334
        },
        {
          x: 957.6,
          y: 587.2
        },
        {
          x: 957.0666666666667,
          y: 592
        },
        {
          x: 956,
          y: 595.2
        },
        {
          x: 953.3333333333334,
          y: 597.0666666666667
        },
        {
          x: 949.3333333333334,
          y: 597.8666666666667
        },
        {
          x: 944.8,
          y: 597.6
        },
        {
          x: 943.2,
          y: 598.9333333333333
        },
        {
          x: 938.1333333333333,
          y: 599.2
        },
        {
          x: 938.4,
          y: 607.2
        },
        {
          x: 943.2,
          y: 607.7333333333333
        },
        {
          x: 949.8666666666667,
          y: 608.2666666666667
        },
        {
          x: 954.6666666666666,
          y: 609.0666666666667
        },
        {
          x: 958.1333333333333,
          y: 613.6
        },
        {
          x: 958.6666666666666,
          y: 620.8
        },
        {
          x: 958.1333333333333,
          y: 628.5333333333333
        }
      ],
      label: 'traffic light'
    },
    {
      key: 'a4f0968e-b073-4a51-ba63-6e221909f2e2',
      label: 'traffic light',
      vertices: [
        {
          x: 1551.25,
          y: 680.4999999999999
        },
        {
          x: 1521,
          y: 681.2500000000001
        },
        {
          x: 1520.75,
          y: 676.5
        },
        {
          x: 1519,
          y: 673.5
        },
        {
          x: 1518.25,
          y: 669.5
        },
        {
          x: 1517.5,
          y: 664
        },
        {
          x: 1518.5,
          y: 661
        },
        {
          x: 1517.5,
          y: 645.75
        },
        {
          x: 1515.25,
          y: 642
        },
        {
          x: 1515.25,
          y: 637.5
        },
        {
          x: 1516.75,
          y: 635
        },
        {
          x: 1515.5,
          y: 617.5
        },
        {
          x: 1513.25,
          y: 614.25
        },
        {
          x: 1513.25,
          y: 610.5
        },
        {
          x: 1513.25,
          y: 606
        },
        {
          x: 1513.75,
          y: 597.75
        },
        {
          x: 1543.25,
          y: 595.25
        }
      ]
    },
    {
      key: '5d1271d8-d986-4d1f-af35-7d4a65163bf4',
      label: 'door',
      vertices: [
        {
          x: 697,
          y: 935.6666666666666
        },
        {
          x: 647,
          y: 938.3333333333334
        },
        {
          x: 642.3333333333334,
          y: 721
        },
        {
          x: 702,
          y: 721
        },
        {
          x: 705,
          y: 936.3333333333334
        }
      ]
    },
    {
      key: '2603b6ee-5673-401f-bff1-6c77650d0030',
      label: 'door',
      vertices: [
        {
          x: 1127,
          y: 740
        },
        {
          x: 1199.3333333333333,
          y: 738.3333333333334
        },
        {
          x: 1199.3333333333333,
          y: 745.3333333333334
        },
        {
          x: 1198,
          y: 747
        },
        {
          x: 1205,
          y: 911
        },
        {
          x: 1200.3333333333333,
          y: 907
        },
        {
          x: 1140,
          y: 906.3333333333334
        },
        {
          x: 1132.3333333333333,
          y: 911.6666666666666
        }
      ]
    },
    {
      key: '0491c04e-9f2b-4fe5-8834-394ac89a1bff',
      vertices: [
        {
          x: 466,
          y: 709
        },
        {
          x: 467,
          y: 950
        },
        {
          x: 432,
          y: 952
        },
        {
          x: 431,
          y: 912
        },
        {
          x: 423,
          y: 905
        },
        {
          x: 422,
          y: 712
        }
      ],
      label: 'door'
    }
  ]
};

export default () => (
  <TaskResponseAnnotation
    imageURL="/static/img/website/solutions/ar-vr/slider/slide-2.jpg"
    hover
    bgTransparent
    annotations={responseAnnotations.annotations}
    responsive
    imageZoomFactor={0.5}
    rounded
  />
);
